// eslint-disable-next-line @typescript-eslint/no-use-before-define
import * as React from 'react';
import { AsyncState } from 'react-use/lib/useAsync';

import { FormError } from '../Form/FormError';
import { Loading } from '../Loading/Loading';

type FetchResultProps<T> = {
    data: AsyncState<T>;
    children: React.ReactNode;
};
export function FetchResult<T>({ data, children }: FetchResultProps<T>) {
    if (data.loading) {
        return <Loading centered />;
    } else if (data.error) {
        return <FormError> Произошла ошибка получения данных </FormError>;
    }
    return <>{children}</>;
}
